import { useLingui } from '@lingui/react/macro';
import { Toaster as Sonner, toast, type ToasterProps } from 'sonner';

import { cn } from './cn';

export { toast };

const base =
  'group flex w-full items-start gap-3 rounded-[10px] border border-border bg-popover px-3.5 py-3 text-sm text-popover-foreground shadow-3 md:w-[356px]';

/**
 * Host único dos toasts (sonner) com tons do Lume. Dispare com `toast.success(título, { description })`;
 * nada de estado de toast por tela (discovery/05 §2.3). A casca monta um só.
 */
export function Toaster(props: ToasterProps) {
  const { t } = useLingui();
  return (
    <Sonner
      position="bottom-right"
      containerAriaLabel={t`Notificações`}
      closeButton
      toastOptions={{
        unstyled: true,
        closeButtonAriaLabel: t`Fechar notificação`,
        classNames: {
          toast: base,
          title: 'font-semibold',
          description: 'mt-0.5 text-muted-foreground',
          icon: 'mt-0.5 [&_svg]:size-icon',
          content: 'min-w-0 flex-1',
          success: cn(base, '[&_[data-icon]]:text-ok'),
          error: cn(base, 'border-err-wash [&_[data-icon]]:text-err'),
          warning: cn(base, '[&_[data-icon]]:text-warn'),
          info: cn(base, '[&_[data-icon]]:text-info'),
          actionButton: 'ml-auto shrink-0 rounded-md bg-primary px-2.5 py-1 text-xs font-medium text-primary-foreground',
          cancelButton: 'shrink-0 rounded-md bg-muted px-2.5 py-1 text-xs font-medium',
          closeButton:
            'absolute -top-2 -left-2 flex size-5 items-center justify-center rounded-full border border-border bg-popover text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
